// Het stoplicht van een beheerkaart of wachter (W6 ronde 2).
//
// Eén bolletje, vier standen uit het contract (`beheer.schema.json#stand`). De
// stand komt ALTIJD van de server — dit component kiest alleen de kleur en het
// woord, nooit het oordeel. Kleur alleen is niet genoeg (kleurenblind, en de
// doelgroep leest woorden sneller dan codes), dus het woord staat in de
// tooltip én in het toegankelijke label.

import type { Stand } from "../../contracts";
import { Tooltip } from "../../components/ui";
import { color } from "../../tokens";

const KLEUR: Record<Stand, string> = {
  goed: color.accentGreen,
  let_op: color.accentAmber,
  rood: color.accentRed,
  leeg: color.disabled,
};

// Review ronde 2: "rood" is een kleur, geen betekenis — wie kleurenblind is of
// de tooltip leest, moet horen wat hij moet doen. Dus het woord zegt de
// gevolgtrekking ("vraagt actie"), de kleur alleen de stand.
const WOORD: Record<Stand, string> = {
  goed: "in orde",
  let_op: "let op",
  rood: "vraagt actie",
  leeg: "niet gemeten",
};

/**
 * `reden`: waarom de stand leeg is, als de server dat zegt. "Niet gemeten"
 * klopt dan vaak niet — een bronrol zonder doel is wél gemeten, hij heeft
 * alleen niets om tegen af te zetten (review W6 ronde 3). Bij een gemeten
 * stand telt alleen het woord.
 */
export function Stoplicht({ stand, reden }: { stand: Stand; reden?: string | null }) {
  const woord = stand === "leeg" && reden ? reden : WOORD[stand];
  return (
    <Tooltip text={woord} maxWidth={woord === WOORD[stand] ? 140 : 260}>
      <span
        role="img"
        aria-label={`stand: ${woord}`}
        data-stand={stand}
        style={{
          display: "inline-block",
          width: 10,
          height: 10,
          borderRadius: 99,
          background: KLEUR[stand],
          flexShrink: 0,
        }}
      />
    </Tooltip>
  );
}
